// @core/api/endpoints/signature/get_party.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PartyResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Get party by ID
 * Returns a single signing party with current status, timestamps, and allowed signature methods.
 */
export async function GetParty(
  party_id: string,
  options?: RequestOptions
): Promise<PartyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/parties/:party_id`;
  requestPath = requestPath.replace(':party_id', encodeURIComponent(party_id));
  const requestOptions = options;
  return client.get<PartyResponse>(requestPath, { ...requestOptions });
}
